import cn from 'classnames';
import React, { useState, useCallback, useContext } from 'react';

import { IntlContext } from '@/i18n';
import { Icon } from '@src-common/view/components/Icon';

import s from './LanguageMenu.module.css';

const getLanguageNameByCode = (languageCode: string): string => {
  switch (languageCode) {
    case 'ru':
      return 'Русский';
    case 'fr':
      return 'Français';
    default:
      return 'English';
  }
};

const LanguageMenu = ({ className }: { className: string }) => {
  const { language: currentLanguage, setLanguage, availableLanguages } = useContext(IntlContext);
  const [isOpened, setIsOpened] = useState(false);

  const toggle = useCallback(() => {
    setIsOpened(prev => !prev);
  }, []);

  const handleLanguageClick = useCallback(
    (language: Parameters<typeof setLanguage>[0]) => () => {
      setLanguage(language);
      setIsOpened(false);
    },
    [setLanguage],
  );

  return (
    <div className={s.languageMenuItem} data-test-id="lang-menu">
      <button
        className={cn(className, s.selectedLanguageItem)}
        onClick={toggle}
        data-test-id="lang-menu__selected"
      >
        {getLanguageNameByCode(currentLanguage)}
        <Icon icon="chevron-to-end" className={cn(s.arrowDown, isOpened && s.arrowUp)} />
      </button>
      {isOpened &&
        availableLanguages
          .filter(language => language !== currentLanguage)
          .map(language => (
            <button
              key={language}
              onClick={handleLanguageClick(language)}
              className={cn(className, s.languageOption)}
              data-test-id="lang-menu__item"
            >
              {getLanguageNameByCode(language)}
            </button>
          ))}
    </div>
  );
};

export { LanguageMenu };
